import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { useScreen } from "@/hooks";
import { PanelCard } from "@/components/common";
import {
  AttributeEditor,
  AttributeLayoutEditor,
} from "@/components/attributes/save";


/**
 * Renders settings for customizing artifact attributes.
 */
const __default__ = {
  name: "AttributeSettings",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { smallWindow } = useScreen();

return (_ctx: any,_cache: any) => {
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_unref(PanelCard), null, {
    default: _withCtx(() => [
      _createVNode(_component_q_layout, {
        container: "",
        view: "lHh Lpr lff",
        class: "settings-attributes"
      }, {
        default: _withCtx(() => [
          (!_unref(smallWindow))
            ? (_openBlock(), _createBlock(_component_q_drawer, {
                key: 0,
                "model-value": "",
                persistent: "",
                bordered: "",
                breakpoint: 0,
                width: 260
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(AttributeEditor))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_page_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_page, { class: "q-mx-md" }, {
                default: _withCtx(() => [
                  (_unref(smallWindow))
                    ? (_openBlock(), _createBlock(_unref(AttributeEditor), { key: 0 }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(AttributeLayoutEditor))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})